import procceedError from './procceed-error';

const timer = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

async function handleErrorAsync<T>(operation: () => Promise<T>): Promise<T> {
  try {
    const result = await operation();
    return result;
  } catch (e) {
    procceedError(e as Error, false);
    await timer(10000);
    throw e;
  }
}

export default handleErrorAsync;
